export default __webpack_public_path__ + "static/media/backsound.930b478f.mp3";